import type { GeoHint } from "@p2p-hls/protocol";

/**
 * Client-side proximity tier, mirroring the tracker's ranking so the scheduler
 * can re-rank locally after connections form. Lower = nearer.
 * 0 same ASN, 1 same region, 2 same country, 3 otherwise.
 */
export function proximityTier(self: GeoHint, other: GeoHint): 0 | 1 | 2 | 3 {
  if (self.asn != null && self.asn === other.asn) return 0;
  if (self.region != null && self.region === other.region) return 1;
  if (self.country != null && self.country === other.country) return 2;
  return 3;
}
